module.exports = __webpack_public_path__ + "static/media/InLottery.71215f28.svg";